import { matrixName, matrixValues, type Context, type ReportRow, type MatrixValue, type MatrixValues } from '@hjci-investorhub-v2/domain';
export interface VisibleMatrixRow { row: ReportRow; depth: number; }
export interface MatrixSort { key: keyof MatrixValues | 'name'; descending: boolean; }
export function visibleMatrixRows(roots: ReportRow[], expanded: Set<string>, sort: MatrixSort[], context: Context, convention: 'ex-date' | 'cash'): VisibleMatrixRow[] {
  const result: VisibleMatrixRow[] = [];
  const compare = (a: MatrixValue, b: MatrixValue, descending: boolean): number => {
    if (a === null || b === null) return a === b ? 0 : a === null ? 1 : -1;
    const difference = typeof a === 'number' && typeof b === 'number' ? a - b : String(a).localeCompare(String(b), 'en', { numeric: true });
    return descending ? -difference : difference;
  };
  const visit = (rows: ReportRow[], depth: number) => {
    const values = new Map(rows.map(row => [row.id, matrixValues(row, context, convention)]));
    [...rows].sort((a, b) => {
      for (const s of sort) { const result = compare(s.key === 'name' ? matrixName(a) : values.get(a.id)![s.key], s.key === 'name' ? matrixName(b) : values.get(b.id)![s.key], s.descending); if (result) return result; }
      return 0;
    }).forEach(row => { result.push({ row, depth }); if (expanded.has(row.id)) visit(row.children, depth + 1); });
  };
  visit(roots, 0); return result;
}
interface TreeRow { id: string; children: TreeRow[]; }
export const treeDepth = (rows: TreeRow[]): number => Math.max(0, ...rows.filter(r => r.children.length).map(r => 1 + treeDepth(r.children)));
export function expandToDepth(rows: TreeRow[], depth: number): Set<string> {
  const ids = new Set<string>();
  const visit = (items: TreeRow[], level: number) => { if (level >= depth) return; for (const row of items) if (row.children.length) { ids.add(row.id); visit(row.children, level + 1); } };
  visit(rows, 0); return ids;
}
